import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SharedModule} from "../../../shared/shared.module";
import { JBMButtonsModule} from "../Buttons/jbmbuttons.module";
import { JBMDropdownsModule} from "../Dropdowns/jbmdropdowns.module";
import { TableLayoutComponent} from "./Layout/tablelayout.component";
import { ColumnFilterComponent } from './ColumnFilter/columnfilter.component';
import { JBMTableComponent } from './JBMTable.component';
import { JBMTableHeaderComponent } from './JBMTableHeader/JBMTableHeader.component';
import { JBMFilterToggleComponent} from './JBMFilterToggle/JBMFilterToggle.component';
import { JBMFilterResetComponent } from './JBMFilterReset/JBMFilterReset.component';
import { ActionDirective } from './action.directive';
import { JBMTableCellComponent } from './JBMTableCell.component';
import { ColumnDirective } from './column.directive';
import { JBMTableColumnComponent } from './JBMTableColumn/JBMTableColumn.component';

@NgModule({
  imports: [CommonModule, NgbModule, SharedModule, JBMButtonsModule, JBMDropdownsModule],
  declarations: [JBMTableComponent, TableLayoutComponent, ColumnDirective, JBMTableColumnComponent, JBMTableCellComponent, ColumnFilterComponent, ActionDirective,
    JBMTableHeaderComponent, JBMFilterToggleComponent, JBMFilterResetComponent],
  exports: [JBMTableComponent, TableLayoutComponent, ColumnDirective, JBMTableColumnComponent, JBMTableCellComponent, ColumnFilterComponent, ActionDirective,
    JBMTableHeaderComponent, JBMFilterToggleComponent, JBMFilterResetComponent]
})
export class JBMTableModule { }
